const Vue = require('vue').default
const VueAwesomeSwiper = require('vue-awesome-swiper')
const moment = require("moment")

Vue.use(VueAwesomeSwiper)

var PageUseful = {
  data: function () {
    return {

    }
  },
  mounted: function () {
    var nav = this.$refs.navScroll
    nav.scrollLeft = 177
  },

  methods: {
  }
}

module.exports = PageUseful